import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperience,
  skillsSection,
  educationInfo,
  certifications,
  linkedInSection,
  articleSection
} from "../../portfolio";

function Header() {
  const {isDark, articles } = useContext(StyleContext);
  const viewExperience = workExperience.display;
  const viewEducation = educationInfo.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = certifications.display;
  const viewLinkedIn = linkedInSection.display;
  const viewArticles = articleSection.display;

  function handleCheckbox(){
    var remember = document.getElementById("menu-btn");
    if (remember.checked) {
      document.getElementById("menu-btn").checked = false;
    } 
  }

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/portfolio/" className="logo">
          &lt;
          <span className="logo-name">{greeting.username}</span>
           /&gt;
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"} onClick={handleCheckbox}>
          {viewSkills && (
            <li>
              <a href="#skills">Skills</a>
            </li>
          )}
          {viewEducation && (
            <li>
              <a href="#education">Education</a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a href="#experience">Experience</a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a href="#achievements">Achievements</a>
            </li>
          )}
          {viewArticles && articles && (
            <li>
              <a href="#articles">Articles</a>
            </li>
          )}
          {viewLinkedIn && (
            <li>
              <a href="#linkedIn">LinkedIn</a>
            </li>
          )}
          <li>
            <a href="#contact">Contact Me</a>
          </li>
          {/* <li>
            <a>
              <ToggleSwitch />
            </a>
          </li> */}
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
